function extractBaseDomain(url: string): string {
  try {
    return new URL(url).origin; // strips hash + path + params
  } catch {
    return url; // fallback for malformed input
  }
}

function getParentAppBaseUrl() {
  const parentRawUrl = document.referrer || window.parent.location.href || window.location.href;
  let baseDomain = extractBaseDomain(parentRawUrl);

  if (baseDomain === 'http://localhost') baseDomain = 'http://localhost/nav-workflow';

  return baseDomain;
}

function getBaseApiUrl() {
  return `${getParentAppBaseUrl()}/api/v1.0`;
}

// function getUrlParameters() {
//   const result: Record<string, string> = {};
//   window.location.search
//     .substring(1)
//     .split('&')
//     .filter(Boolean)
//     .forEach((param) => {
//       const [name, ...valueParts] = param.split('=');
//       result[decodeURIComponent(name)] = valueParts.length ? decodeURIComponent(valueParts.join('=')) : '';
//     });
//   return result;
// }

function getUrlParameters() {
  const params = new URLSearchParams(window.location.search);

  return {
    phone: params.has('p'),
    email: params.has('e'),
    token: params.get('p') || params.get('e') || '',
    order: params.get('o') || '',
    input: params.get('i'),
  };
}

const clamp = (number: number, min: number, max: number) =>
  Math.max(Math.min(number, Math.max(min, max)), Math.min(min, max));

function countNonEmptyFields(obj: Record<string, string>): number {
  return Object.values(obj).filter((value) => value.trim() !== '').length;
}

function sortByKeys<T>(...keys: (keyof T)[]) {
  return (a: T, b: T) => {
    for (const key of keys) {
      const diff = Number(a[key]) - Number(b[key]);
      if (diff !== 0) return diff;
    }
    return 0;
  };
}

// find the next item strictly greater by (key1, key2) after the current element in sorted array
function getNextLineFromSorted<T>(sorted: T[], current: T, key1: keyof T, key2: keyof T): T | null {
  // find index by identity first (fast & correct if you passed an element from that array)
  let idx = sorted.findIndex((r) => r === current);

  // if not found by identity, try to find by key values (useful if current is a detached equivalent object)
  if (idx === -1) {
    const cur1 = Number(current[key1]);
    const cur2 = Number(current[key2]);
    idx = sorted.findIndex((r) => Number(r[key1]) === cur1 && Number(r[key2]) === cur2);
  }

  if (idx === -1) return null;

  const curKey1 = Number(sorted[idx][key1]);
  const curKey2 = Number(sorted[idx][key2]);

  for (let i = idx + 1; i < sorted.length; i++) {
    const r = sorted[i];
    const r1 = Number(r[key1]);
    const r2 = Number(r[key2]);

    if (isNaN(r1) || isNaN(r2)) {
      // if either value isn't numeric, fall back to string compare
      const cur1Str = String(curKey1);
      const cur2Str = String(curKey2);
      const r1Str = String(r[key1]);
      const r2Str = String(r[key2]);
      if (r1Str > cur1Str || (r1Str === cur1Str && r2Str > cur2Str)) return r;
    } else {
      if (r1 > curKey1 || (r1 === curKey1 && r2 > curKey2)) return r;
    }
  }

  return null;
}

export { clamp, getBaseApiUrl, getUrlParameters, countNonEmptyFields, sortByKeys, getNextLineFromSorted };
